import { LINKEDIN_LEGACY_INDICATORS_BY_CONTEXT_TYPE } from './legacyIndicators/linkedinLegacyIndicators';
import { LINKEDIN_RECRUITER_LITE_LEGACY_INDICATORS_BY_CONTEXT_TYPE } from './legacyIndicators/linkedinRecLiteLegacyIndicators';
import { LINKEDIN_RECRUITER_PRO_LEGACY_INDICATORS_BY_CONTEXT_TYPE } from './legacyIndicators/linkedinRecProLegacyIndicators';
import { LINKEDIN_SALES_NAVIGATOR_LEGACY_INDICATORS_BY_CONTEXT_TYPE } from './legacyIndicators/linkedinSalesNavLegacyIndicators';

export const getLegacyLinkedinPageIndicators = context => ({
  selectors: [],
  observers: {
    experienceElement: [{ element: 'background-details', attribute: 'class' }],
    experiencesCount: [{ element: 'pv-profile-section__card-heading', attribute: 'class' }],
    profileSectionContainerMutate: [{ element: 'profile-detail', attribute: 'class', childLocation: 0 }],
  },
  indicatorIterations: {
    numOfIterations: 7,
    millisPerIteration: 1000,
  },
  indicators: {
    LINKEDIN: LINKEDIN_LEGACY_INDICATORS_BY_CONTEXT_TYPE[context],
    LINKEDIN_RECRUITER_LITE: LINKEDIN_RECRUITER_LITE_LEGACY_INDICATORS_BY_CONTEXT_TYPE[context],
    LINKEDIN_RECRUITER_PRO: LINKEDIN_RECRUITER_PRO_LEGACY_INDICATORS_BY_CONTEXT_TYPE[context],
    LINKEDIN_SALES_NAVIGATOR: LINKEDIN_SALES_NAVIGATOR_LEGACY_INDICATORS_BY_CONTEXT_TYPE[context],
  },
  linkedinProfilePageLoadSettings: {
    pendingElementSelector: '.pv-occludable__background', // deprecated on 12.10.2021, Contact Page - Contact hidden Sections , (experience, about, education), (Lusha Contacts)
    pendingElementsSelectors: [
      { selector: '.pv-occludable__background' },
    ],
    verifyLoadSettings: {
      numOfIterations: 80,
      millisPerIteration: 40,
    },
    scrollVolume: 5,
  },
  salesNavBulkLoadElementsSettings: {
    contactCardClass: '.search-results__result-item', // deprecated on 1.9.2021, we should wait until remove it to support old plugin versions
    readyToLoadIndicator: '.deferred-area--pending', // deprecated on 1.9.2021, we should wait until remove it to support old plugin versions
    pendingElementSelector: '.deferred-area--pending', // deprecated on 12.10.2021, Search Page - Hidden Contacts Container (Bulk Enrich)
    pendingElementsSelectors: [
      { selector: '.deferred-area--pending' },
      { selector: 'div[data-test-deferred-did-intersect]', pendingChildrenSelector: '.dummy-button-medium' },
    ],
    verifyLoadSettings: {
      numOfIterations: 80,
      millisPerIteration: 40,
    },
    scrollVolume: 5,
  },
});
